const getMapUrl = (
  address: string,
  city: string,
  state: string,
  zip: string | number
): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${address}, ${city},${state} ${zip}`
  )}`;

export default getMapUrl;
